import TreatmentPage from "./TreatmentPage";

export default function HairTreatment() {
  return (
    <TreatmentPage
      title="Hair Treatment."
      heroImage="/Treatment/hair-treatment-drTruptis-clinic.png"
      intro="Hair fall, Hair dandruff, Alopecia areata, Seborrheic Dermatitis, Telogen Effluvium ..these are the common Hair diseases..."
      description="Internal + External local application treatment Available.
                  Procedure - PRP ( platalate rich plasma) , Microneedling, Hair mesotherapy, available.
                  Hair PRP - Into your blood plasma will be separated with centrifuge machine and inject into scalp."
      howItWorks="How it works- processed to isolate growth factor-rich plasma—injected into the scalp to stimulate hair follicles, reverse thinning, and promote hair growth ."
      benefits={[
        "It increases blood circulation to the scalp",
        "strengthens existing hair",
        "reduces shedding",
        "increases hair shaft thickness",
      ]}
      beforeAfterImages={[
        "/Treatment/before-hair-treatment-truptis-clinic.jpeg",
        "/Treatment/after-hair-treatment-truptis-clinic.jpeg",
      ]}
      faqs={[
        { q: "Is it painful?", a: "Mild discomfort only, done under cooling gel." },
        { q: "How many sessions needed?", a: "Usually 6-8 sessions." },
        { q: "Is there any side Effect?", a: "As it uses the patient's own blood, it is safe with minimal risks, which may include minor soreness, swelling, or temporary, light bleeding at the injection site." },
      ]}
    />
  );
}
